import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: MetaPixelFunction;
  loaded?: boolean;
  version?: string;
};
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const pixel = ((...args: unknown[]) => {
      if (pixel.callMethod) {
        pixel.callMethod(...args);
      } else {
        pixel.queue.push(args);
      }
    }) as MetaPixelFunction;
    pixel.queue = [];
    pixel.push = pixel;
    pixel.loaded = true;
    pixel.version = '2.0';
    window.fbq = pixel;
    window._fbq = pixel;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    pixel('init', '1492774178719165');
    pixel('track', 'PageView');
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1492774178719165&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>
      <div className="min-h-screen bg-brand-ivory text-brand-text overflow-x-hidden flex flex-col items-center" data-id="element-2">
        <div className="w-full max-w-2xl bg-white shadow-2xl" data-id="element-3">
          <UrgencyBanner data-id="element-4" />
          <Hero data-id="element-5" />
          <PainSection data-id="element-6" />
          <SolutionSection data-id="element-7" />
          <BonusSection data-id="element-8" />
          <BenefitsSection data-id="element-9" />
          <PricingCard data-id="element-10" />
          <Guarantee data-id="element-11" />
          <Testimonials data-id="element-12" />
          <FAQ data-id="element-13" />
          <FinalCTA data-id="element-14" />
          <Footer data-id="element-15" />
        </div>
      </div>
    </>;
}